import { React, useRef, useEffect, useState } from 'react';
import styled from 'styled-components';

import WhiteCrownImage from '../../../image/WhiteCrown.png';

import { useLanguage } from '../../../Context/LanguageContext';

export default function NewDataBar(props) {
  const { data, today, index, thisYear, maximum, thisYearMaxPrice, totalMaxPrice } = props;

  const { t } = useLanguage();

  const [cardWidth, setCardWidth] = useState(0);
  const [cashWidth, setCashWidth] = useState(0);
  const [discountWidth, setDiscountWidth] = useState(0);
  const [notReceiveWidth, setNotReceiveWidth] = useState(0);

  const [totalWidth, setTotalWidth] = useState(0);
  const [noneWidth, setNoneWidth] = useState(0);

  const HoverRef = useRef();

  // 데이터바 크기 결정 //
  useEffect(() => {
    if (maximum === 0) {
      setTotalWidth(0);
      return;
    }

    const maxWidth = 270;

    let totalPrice = (data.cardPrice + data.cashPrice);

    if ((data.cardPrice + data.cashPrice + data.discountPrice + data.notReceived) === 0) {
      if (data.sales.length > 0) setTotalWidth(0);
      else setTotalWidth(((maximum / 2) * maxWidth) / maximum);
    }
    else setTotalWidth((totalPrice * maxWidth) / maximum);
  }, [data, maximum])

  // 마우스 호버링시 //
  function mouseOver(e) {
    if (data.totalPrice === 0 && data.sales.length === 0) return;
    
    HoverRef.current.style.zIndex = 5;
    HoverRef.current.style.opacity = 1;
  }

  // 마우스 호버링시 //
  function mouseLeave() {
    if (data.totalPrice === 0 && data.sales.length === 0) return;

    HoverRef.current.style.zIndex = -5;
    HoverRef.current.style.opacity = 0;
  }

  // 월간 매출 증감률 계산 //
  function decideMonthlyRevenueChangeRate() {
    if (thisYear.length === 0) return '0%';
    else if (index === 0) {
      let thisMonth = thisYear[index].totalPrice;
      let prevMonth = thisYear[11].prevTotalPrice;

      if (prevMonth === 0) return t('statistics.chart.noStandard');
      else if (thisMonth === 0) return '0%';
      else {
        let totalPercent = parseInt(((thisMonth - prevMonth) / prevMonth) * 100);

        if (totalPercent > 0) return '+' + totalPercent + '%';
        else return totalPercent + '%';
      }
    }
    else {
      let thisMonth = thisYear[index].totalPrice;
      let prevMonth = thisYear[index - 1].totalPrice;

      if (prevMonth === 0) return t('statistics.chart.noStandard');
      else if (thisMonth === 0) return '0%';
      else {
        let totalPercent = parseInt(((thisMonth - prevMonth) / prevMonth) * 100);

        if (totalPercent > 0) return '+' + totalPercent + '%';
        else return totalPercent + '%';
      }
    }
  }

  // 월간 매출 증감률에 따른 박스 색상 결정 //
  function decideMonthlyRevenueChangeRateColorBox() {
    if (thisYear.length === 0) return '#C6C6C6';
    else if (index === 0) {
      let thisMonth = thisYear[index].totalPrice;
      let prevMonth = thisYear[11].prevTotalPrice;

      if (prevMonth === 0 || thisMonth === 0) return '#C6C6C6';
      else if (parseInt(((thisMonth - prevMonth) / prevMonth) * 100) > 0) return '#D92828';
      else return '#2F80ED';
    }
    else {
      let thisMonth = thisYear[index].totalPrice;
      let prevMonth = thisYear[index - 1].totalPrice;

      if (prevMonth === 0 || thisMonth === 0) return '#C6C6C6';
      else if (parseInt(((thisMonth - prevMonth) / prevMonth) * 100) > 0) return '#D92828';
      else return '#2F80ED';
    }
  }

  // 년간 매출 증감률 계산 //
  function decideYearRevenueChangeRate() {
    if (thisYear.length === 0) return '0%';
    else {
      let thisMonth = thisYear[index].totalPrice;
      let prevMonth = thisYear[index].prevTotalPrice;

      if (prevMonth === 0) return t('statistics.chart.noStandard');
      else if (thisMonth === 0) return '0%';
      else {
        let totalPercent = parseInt(((thisMonth - prevMonth) / prevMonth) * 100);

        if (totalPercent > 0) return '+' + totalPercent + '%';
        else return totalPercent + '%';
      }
    }
  }

  // 연간 매출 증감률에 따른 박스 색상 결정 //
  function decideYearRevenueChangeRateColorBox() {
    if (thisYear.length === 0) return '#C6C6C6';
    else {
      let thisMonth = thisYear[index].totalPrice;
      let prevMonth = thisYear[index].prevTotalPrice;

      if (prevMonth === 0 || thisMonth === 0) return '#C6C6C6';
      else if (parseInt(((thisMonth - prevMonth) / prevMonth) * 100) > 0) return '#D92828';
      else return '#2F80ED';
    }
  }

  // 링코페이 금액 계산 함수 //
  // cardPrice와 selectedPaymentOptions 양쪽에 금액이 존재할 수 있으므로 cardPrice를 우선 사용하고, //
  // cardPrice가 0인 경우 selectedPaymentOptions에서 paymentOptionId === 0인 항목의 금액을 사용 //
  function calculateLinkoPayPrice() {
    if (!data.sales || data.sales.length === 0) return 0;

    // 환불된 merchantUid 목록 수집 //
    const refundedMerchantUids = new Set();

    for (const sale of data.sales) {
      if (sale.isRefund && sale.merchantUid) {
        refundedMerchantUids.add(sale.merchantUid);
      }
    }

    let linkoPayTotal = 0;

    for (const sale of data.sales) {
      if (!sale.merchantUid || sale.isRefund) continue;
      // 환불된 거래는 제외 //
      if (refundedMerchantUids.has(sale.merchantUid)) continue;

      const segments = sale.merchantUid.split('-');

      if (segments.length >= 4 && (segments[2] === '1' || segments[2] === '2')) {
        // cardPrice 우선, 0이면 selectedPaymentOptions에서 확인 (중복 방지) //
        if (sale.cardPrice) {
          linkoPayTotal += sale.cardPrice;
        }
        else if (sale.selectedPaymentOptions && sale.selectedPaymentOptions.length > 0) {
          for (const option of sale.selectedPaymentOptions) {
            if (option.paymentOptionId === 0) {
              linkoPayTotal += (option.price || 0);
              break;
            }
          }
        }
      }
    }

    return linkoPayTotal;
  }

  // 데이터 바 색상 결정 //
  function decideDataBarBackgroundColor() {
    if (totalMaxPrice < thisYear[index].totalPrice) return '#FFB800';
    else if (thisYearMaxPrice <= thisYear[index].totalPrice) return '#FF8B48';
    else return '#C6C6C6';
  }

  // 데이터 바 텍스트 결정 //
  function decideDataBarText() {
    if (totalMaxPrice < thisYear[index].totalPrice) {
      return (
        <AllTimeMaxSalesWrapper>
          <CrownImage src={WhiteCrownImage}/>
          <MaxSalesWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={10} color='#FFFFFF' cursor='pointer'>{t('statistics.chart.allRecordHighSales')}</Text>
            <Text fontFamily='NotoSansKR-Bold' fontSize={10} color='#FFFFFF' cursor='pointer'>{data.totalPrice.toLocaleString('ko-KR') + ' ' + t('statistics.won')}</Text>
          </MaxSalesWrapper>
        </AllTimeMaxSalesWrapper>
      )
    }
    else if (thisYearMaxPrice <= thisYear[index].totalPrice) {
      return (
        <MaxSalesWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={10} color='#FFFFFF' cursor='pointer'>{t('statistics.chart.maxSales')}</Text>
          <Text fontFamily='NotoSansKR-Bold' fontSize={10} color='#FFFFFF' cursor='pointer'>{data.totalPrice.toLocaleString('ko-KR') + ' ' + t('statistics.won')}</Text>
        </MaxSalesWrapper>
      )
    }
    else return <Text fontFamily='NotoSansKR-Bold' fontSize={10} color='#FFFFFF' cursor='pointer'>{data.totalPrice.toLocaleString('ko-KR') + ' ' + t('statistics.won')}</Text>
  }

  return (
    <TopLevelWrapper onMouseLeave={mouseLeave} onMouseOver={mouseOver}>
      <DataShape width={totalWidth} color={decideDataBarBackgroundColor()}>
        <DataTextWrapper>
          {decideDataBarText()}
        </DataTextWrapper>
      </DataShape>
      <SalesComparisonBoxWrapper>
        <SalesComparisonBox>
          <Text fontFamily='NotoSansKR-Bold' fontSize={10} color='#777777' cursor='default'>MOM</Text>
          <SalesComparisonPersentBox backgroundColor={decideMonthlyRevenueChangeRateColorBox()}>
            <Text style={{ marginTop: '-2px' }} fontFamily='NotoSansKR-Bold' fontSize={10} color='#FFFFFF' cursor='default'>{decideMonthlyRevenueChangeRate()}</Text>
          </SalesComparisonPersentBox>
        </SalesComparisonBox>
        <SalesComparisonBox>
          <Text fontFamily='NotoSansKR-Bold' fontSize={10} color='#777777' cursor='default'>YOY</Text>
          <SalesComparisonPersentBox backgroundColor={decideYearRevenueChangeRateColorBox()}>
            <Text style={{ marginTop: '-2px' }} fontFamily='NotoSansKR-Bold' fontSize={10} color='#FFFFFF' cursor='default'>{decideYearRevenueChangeRate()}</Text>
          </SalesComparisonPersentBox>
        </SalesComparisonBox>
      </SalesComparisonBoxWrapper>
      <HoverBox ref={HoverRef}>
        <InfoBox>
          <ColumnTitleWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#232323' cursor='default'>{today.clone().format(t('statistics.dateFormatYear')) + ' ' + (index + 1) + t('statistics.chart.monthlySales')}</Text>
          </ColumnTitleWrapper>
          <HoverColumnWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#232323' cursor='default'>{t('statistics.chart.totalSales')}</Text>
            <PriceColumnWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{data.totalPrice.toLocaleString('ko-KR')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#969696' cursor='default'>{t('statistics.won')}</Text>
            </PriceColumnWrapper>
          </HoverColumnWrapper>
          <HoverColumnWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#232323' cursor='default'>{t('statistics.chart.cash')}</Text>
            <PriceColumnWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{data.cashPrice.toLocaleString('ko-KR')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#969696' cursor='default'>{t('statistics.won')}</Text>
            </PriceColumnWrapper>
          </HoverColumnWrapper>
          <HoverColumnWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#232323' cursor='default'>{t('statistics.chart.card')}</Text>
            <PriceColumnWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{(data.cardPrice - calculateLinkoPayPrice()).toLocaleString('ko-KR')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#969696' cursor='default'>{t('statistics.won')}</Text>
            </PriceColumnWrapper>
          </HoverColumnWrapper>
          <HoverColumnWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#232323' cursor='default'>{t('statistics.chart.linkoPay')}</Text>
            <PriceColumnWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{calculateLinkoPayPrice().toLocaleString('ko-KR')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#969696' cursor='default'>{t('statistics.won')}</Text>
            </PriceColumnWrapper>
          </HoverColumnWrapper>
          {
            data.selectedPaymentOptions.map((paymentOptionData, paymentOptionIndex) => (
              <HoverColumnWrapper key={'SelectedPaymentOptions-' + paymentOptionIndex}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#232323' cursor='default'>{paymentOptionData.paymentOptionName}</Text>
                <PriceColumnWrapper>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{paymentOptionData.price.toLocaleString('ko-KR')}</Text>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#969696' cursor='default'>{t('statistics.won')}</Text>
                </PriceColumnWrapper>
              </HoverColumnWrapper>
            ))
          }
          <HoverColumnWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#D92828' cursor='default'>{t('statistics.chart.notReceived')}</Text>
            <PriceColumnWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#D92828' cursor='default'>{data.notReceived.toLocaleString('ko-KR')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#D92828' cursor='default'>{t('statistics.won')}</Text>
            </PriceColumnWrapper>
          </HoverColumnWrapper>
        </InfoBox>
      </HoverBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 28px;

  overflow: hidden;
  border-radius: 0px 2px 2px 0px;

  transition: all 0.3s ease-in-out;
`;

const DataShape = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: ${props => props.width}px;
  height: 20px;

  border-radius: 0px 5px 5px 0px;
  background-color: ${props => props.color};

  font-family: NotoSansKR-Bold;
  font-size: 10px;

  overflow: hidden;
  color: #FFFFFF;

  &:hover {
    cursor: pointer;
  }
`;

const DataTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  padding: 0px 4px;

  width: calc(100% - 8px);
  height: 15px;

  overflow: hidden;
`;

const AllTimeMaxSalesWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const MaxSalesWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const CrownImage = styled.img`
  width: 10px;
  height: 10px;
`;

const DataPercent = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 10px;

  color: #FFFFFF;

  margin: 0 0 0 3px;
`;

const HoverBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 10px;

  width: 259px;

  z-index: -5;
  opacity: 0;

  margin-top: 161px;
  margin-left: 161px;

  border: 1px solid #DFDFDF;
  border-radius: 5px;
  box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
  background-color: #FFFFFF;
  
  transition: all 0.3s ease-in-out;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const ColumnTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start
  align-items: center;

  width: 100%;
`;

const HoverColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const PriceColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  gap: 8px;
`;

const SalesComparisonBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 142px;

  gap: 8px;
`;

const SalesComparisonBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 2px;
`;

const SalesComparisonPersentBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 2px;

  height: 16px;

  border-radius: 4px;
  background-color: ${props => props.backgroundColor};
`;

const Column = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #595959;

  margin: 0 0 0 0;
`;

const Content = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #595959;

  margin: 0 0 0 0;
`;

const Unit = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #BABABA;

  margin: 0 0 0 0;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
  
  transition: all 0.3s ease-in-out;
`;